import { writable } from "svelte/store";


function Controller(){
    const {subscribe, set, update} = writable({
        membership_selected: null,
        current_item_tab: null,
        plans_views: [],
    })



    const controller = {
        subscribe,
        // reset states and force reload reactivity
        reset: ()=>{
            update(( data )=>{
                return {...data};
            });
        },
        update: (field, content)=>{
            update(( data )=>{
                data[field] = content;
                return data;
            })
        }
    }


    return controller;
}


export const PlansStore = Controller();